import { times } from 'ramda';

import { CANTON_OPTIONS as CANTONS } from 'utils/constants';
import { ALL } from 'store/invoices';

export const CANTON_OPTIONS = [{ id: ALL, label: 'Alle Kantone' }, ...CANTONS];

export const YEAR_OPTIONS = (() => {
  const current = new Date().getFullYear();

  return times((i) => current - i, current - 2018).map((year) => ({
    id: year,
    label: year === current ? 'Laufendes Geschäftsjahr' : String(year),
  }));
})();
